<template>
  <v-dialog v-model="dialog" :width="$vuetify.display.smAndUp ? 500 : 'auto'">
    <v-card>
      <v-card-title class="d-flex justify-space-between" data-cy="dialog-uploadFiles-uploadFilesTooltips-title">
        <span>{{ $t('menus.uploadFiles.tipsForUploadingFilesTitle') }}</span>
        <v-btn icon @click="dialog = false" variant="text" aria-label="Close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="scrollable mt-4 text-content">
        <div>
          <h4 class="text-subtitle-1 font-weight-bold mb-2">{{ $t('menus.uploadFiles.tipsForUploadingFiles.uploadingFilesHeading') }}:</h4>
          <ul class="mb-4">
            <li class="text-body-1 mb-2">{{ $t('menus.uploadFiles.tipsForUploadingFiles.dontCloseProgressWhileInProgress') }}</li>
            <li class="text-body-1 mb-2">{{ $t('menus.uploadFiles.tipsForUploadingFiles.ensureComputerDoesNotEnterStandby') }}</li>
          </ul>
        </div>

        <div class="mt-4">
          <h4 class="text-subtitle-1 font-weight-bold mb-2">{{ $t('menus.uploadFiles.tipsForUploadingFiles.uploadingLargeFilesHeading') }}:</h4>
          <ul>
            <li class="text-body-1 mb-2">{{ $t('menus.uploadFiles.tipsForUploadingFiles.tryAvoidingMobileConnections') }}</li>
            <li class="text-body-1 mb-2">
              {{ $t('menus.uploadFiles.tipsForUploadingFiles.ifUsingBrowserTurnOff', { browser: 'Chrome' }) }}
              <a href="https://support.google.com/chrome/answer/12929150?hl=en#zippy=%2Cturn-memory-saver-on-or-off" target="_blank" class="text-decoration-none">
                memory saver
              </a>
            </li>
            <li class="text-body-1 mb-2">
              {{ $t('menus.uploadFiles.tipsForUploadingFiles.ifUsingBrowserTurnOff', { browser: 'Firefox' }) }}
              <a href="https://firefox-source-docs.mozilla.org/browser/tabunloader/" target="_blank" class="text-decoration-none">
                tab unloader
              </a>
            </li>
          </ul>
        </div>
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="text" @click="dialog = false" data-cy="dialog-uploadFiles-uploadFilesTooltips-closeButton">
          {{ $t('common.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';

export default {
  emits: ["close"],
  name: "UploadingFilesTipsDialog",
  mixins: [DialogActionKeys],

  props: {
    isVisible: {
      type: Boolean,
      required: true,
    }
  },

  data() {
    return {
      dialog: this.$props.isVisible,
    }
  },

  watch: {
    isVisible(val) {
      this.dialog = val;
    },
    dialog(val) {
      if (!val) {
        this.$emit('close');
      }
    }
  }
};
</script>

<style scoped>
.text-content {
  font-size: 1.1rem;
  line-height: 1.6;
}

.text-content h4 {
  font-size: 1.25rem;
  /*margin-bottom: 12px;*/
}

.text-content ul {
  padding-left: 20px;
}

.text-content li {
  /*margin-bottom: 10px;*/
}

.text-content a {
  color: var(--v-primary-base);
  font-weight: 500;
}

.v-theme--dark .text-content a {
  color: var(--v-primary-lighten2);
}
</style>
